export class UpdateMealCategoryTierEntity {
  addedMealTiers?: Array<{
    mealTierId?: number
  }>
  removedMealTiers?: Array<{
    mealTierId?: number
  }>
}
